import { Loader2 } from 'lucide-react';

/**
 * Reusable loading states
 */

/** Full-page / section spinner */
export function PageLoader({ text = 'Loading…' }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 gap-3">
      <Loader2 size={28} className="text-brand-blue animate-spin" />
      <p className="text-[13px] text-slate-500 font-medium">{text}</p>
    </div>
  );
}

/** Inline small spinner */
export function InlineLoader({ size = 16, className = '' }) {
  return <Loader2 size={size} className={`animate-spin text-brand-blue ${className}`} />;
}

/** Skeleton rectangle placeholder */
export function Skeleton({ className = '', rounded = 'rounded' }) {
  return (
    <div
      className={`bg-slate-100 animate-pulse ${rounded} ${className}`}
    />
  );
}




